export default "__VITE_ASSET__bcc9eef3__"